import {CoffeeConsumptionStatistics, CoffeeMachineConsumption} from "./CoffeeMachineJsonMapper";

export class WidgetsPageData {
    private loading = false;
    private automaticWashes: number = null;
    private manualWashes: number = null;
    private consumptions: number = null;
    private consumptionsList: CoffeeMachineConsumption[] = null;
    private consumptionsOnActiveDays: number = null;
    private purges: number = null;
    private numberOfActiveDays: number = null;
    private consumptionsStatistics: CoffeeConsumptionStatistics = null;

    public loaded(): boolean {
        return (
            this.automaticWashes != null
            && this.manualWashes != null
            && this.consumptions != null
            && this.consumptionsList != null
            && this.consumptionsOnActiveDays != null
            && this.purges != null
            && this.numberOfActiveDays != null
            && this.consumptionsStatistics != null
        );
    }

    public reset(): void {
        this.automaticWashes = null;
        this.manualWashes = null;
        this.consumptions = null;
        this.purges = null;
        this.consumptionsList = null;
        this.numberOfActiveDays = null;
        this.consumptionsStatistics = null;
    }

    public clone(): WidgetsPageData {
        const result = new WidgetsPageData();
        result.loading = this.loading;
        result.automaticWashes = this.automaticWashes;
        result.manualWashes = this.manualWashes;
        result.consumptions = this.consumptions;
        result.consumptionsList = this.consumptionsList;
        result.consumptionsOnActiveDays = this.consumptionsOnActiveDays;
        result.purges = this.purges;
        result.numberOfActiveDays = this.numberOfActiveDays;
        result.consumptionsStatistics = this.consumptionsStatistics;
        return result;
    }

    public getConsumptionsOnActiveDays(): number {
        return this.consumptionsOnActiveDays;
    }

    public setConsumptionsOnActiveDays(consumptionsOnActiveDays: number) {
        this.consumptionsOnActiveDays = consumptionsOnActiveDays;
    }

    public isLoading(): boolean {
        return this.loading;
    }

    public setLoading(loading: boolean) {
        this.loading = loading;
    }

    public getAutomaticWashes() {
        return this.automaticWashes;
    }

    public setAutomaticWashes(washes: number) {
        this.automaticWashes = washes;
    }

    public getManualWashes() {
        return this.manualWashes;
    }

    public setManualWashes(washes: number) {
        this.manualWashes = washes;
    }

    public getNumberOfActiveDays() {
        return this.numberOfActiveDays;
    }

    public setNumberOfActiveDays(numberOfActiveDays: number) {
        this.numberOfActiveDays = numberOfActiveDays;
    }

    public getConsumptions() {
        return this.consumptions;
    }

    public setConsumptions(consumptions: number) {
        this.consumptions = consumptions;
    }

    public getPurges() {
        return this.purges;
    }

    public setPurges(purges) {
        this.purges = purges;
    }

    public getConsumptionsList() {
        return this.consumptionsList;
    }

    public setConsumptionsList(consumptionsList: CoffeeMachineConsumption[]) {
        this.consumptionsList = consumptionsList;
    }

    public getConsumptionsStatistics() {
        return this.consumptionsStatistics;
    }

    public setConsumptionsStatistics(statistics: CoffeeConsumptionStatistics) {
        this.consumptionsStatistics = statistics;
    }
}
